module.exports = __webpack_public_path__ + "img/3.daf8bc1c.png";